const CATEGORIES_TABLE_READY = "categorys-table-ready"
const SEARCH_TEXT_STATE = "categorys-table-search-text-state"
const ROWS_PER_PAGE_STATE = "categorys-table-rows-per-page-state"
const PAGINATION_STATE = "categorys-table-pagination-state"

const CATEGORY_ID_FOR_ACTION = "categorys-table-category-id-for-action"

const ADD_EDIT_CATEGORY_READY = "add-edit-category-ready"


const PREVIOUS_CATEGORY_FILTER_CITY = "previous-category-filter-status-action"




const initialState = {
    isCategoriesTableReady: true,
    isAddEditCategoryReady:true,
    categorys: {},

    
    categorySelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,

    previousFilterCity : "",
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case CATEGORIES_TABLE_READY:
            return Object.assign({}, state, { isCategoriesTableReady: action.payload })
        case ADD_EDIT_CATEGORY_READY:
            return Object.assign({}, state, { isAddEditCategoryReady: action.payload })
        


        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case CATEGORY_ID_FOR_ACTION:
            return Object.assign({}, state, {categorySelectedId:action.payload})

        case PREVIOUS_CATEGORY_FILTER_CITY:
            return Object.assign({}, state, {previousFilterCity:action.payload})

        default:
        return state
    
    }

}

export function categoryTableReady(data) {
    return {
        type: CATEGORIES_TABLE_READY,
        payload: data
    }
}


export function addEditCategoryReady(data) {
    return {
        type: ADD_EDIT_CATEGORY_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function categoryIdForAction(categoryId){
    return{
        type:CATEGORY_ID_FOR_ACTION,
        payload:categoryId
    }
}

export function previousFilterCity(filterVal){
    return{
        type:PREVIOUS_CATEGORY_FILTER_CITY,
        payload:filterVal
    }
}






// WEBPACK FOOTER //
// ./src/modules/Categories/redux/categories.js